import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useApiQuery } from '../../../../hooks/useApiQuery.js'

/**
 * Hook for LanesSidebar logic
 * Provides lanes data and counts for sidebar navigation
 *
 * Migrated from MobX to React Query
 * Uses useApiQuery to fetch lanes and computes counts from data
 */
export const useLanesSidebar = () => {
  const [searchParams] = useSearchParams()

  // Preserve the current search/sort params when switching between the
  // Active and Archived lists — otherwise the active search is dropped.
  const queryString = searchParams.toString()
  const activeHref = queryString
    ? `/lanes/active?${queryString}`
    : '/lanes/active'
  const archivedHref = queryString
    ? `/lanes/archived?${queryString}`
    : '/lanes/archived'

  // Fetch all lanes using React Query
  const {
    data: lanes = [],
    isLoading,
    error,
  } = useApiQuery({
    key: ['getLanes'],
    payload: {},
    showToast: false, // Don't show toast for sidebar data fetch
  })

  // Compute active and archive counts from lanes data
  const { activeCount, archiveCount } = useMemo(() => {
    if (!Array.isArray(lanes)) {
      return { activeCount: 0, archiveCount: 0 }
    }

    return {
      activeCount: lanes.filter((lane) => lane.state === 'active').length,
      archiveCount: lanes.filter((lane) => lane.state === 'archived').length,
    }
  }, [lanes])

  return {
    lanes,
    activeCount,
    archiveCount,
    isLoading,
    error,
    activeHref,
    archivedHref,
  }
}
